import React from 'react';
import { PhoneIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../profile/Urls';
import DataCard from './DataCard';

export default function Phone(props) {
  const { user } = props;

  const { history } = useRouter();

  return (
    <DataCard
      title="Phone Number"
      icon={PhoneIcon}
      subtitle={user.data.phoneNumber || '(not provided)'}
      onClick={() => history.push(Urls(user).PHONE)}
    />
  );
};
